import React from "react";
import Notification from "../Notification/Notification";
import Header from "../Header/Header";
import Advantages from "../Advantages/Advantages";
import TelegramLink from "../TelegramLink/TelegramComponent";
import Partners from "../Partners/Partners";
import FooterLinks from "../FooterLinks/FooterLinks";
import ExchangeBlock from "../ExchangeBLock/ExchangeBlock";
import "./CryptoExchanger.css"
import FastExchange from "../FastExchange/FastExchange";
import {useLocation} from "react-router-dom";
import JivoChatWidget from "../JivoChat/JivoChatWidget";
import {ExchangeProvider} from "../../Context/Exchange";
import ExchangeResult from "../ResultMessage/ExchangeResult";

function CryptoExchanger() {
    const location = useLocation();
    const isFastExchange = location.pathname === "/fast-exchange";
    const isExchangeResult = location.pathname === "/exchange-result";

    return (
        <ExchangeProvider>
            <div className="page-container">
                <Notification />
                <Header />

                <div className="content">
                    {isFastExchange ? (
                        <div className="middle-part">
                            <FastExchange />
                        </div>
                    ) : isExchangeResult ? (
                        <div className="middle-part">
                            <ExchangeResult requestNumber={location.state?.requestNumber} />
                        </div>
                    ) : (
                        <div className="middle-part">
                            <ExchangeBlock />
                            <Advantages />
                            <TelegramLink />
                        </div>
                    )}
                </div>

                <div className="partner-footer">
                    <Partners />
                    <FooterLinks />
                </div>
                <JivoChatWidget />
            </div>
        </ExchangeProvider>
    );
}

export default CryptoExchanger;